export default function subtract<T extends number>(
  a: T,
  b: NoInfer<T | number>,
): T {
  return (a - b) as T;
}
